// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + ({"3066":"quick-registration","3524":"app"}[chunkId] || chunkId) + "." + {"1506":"9a2f91a7","3066":"3e5d582a","3404":"9a2f91a7","3524":"9a2f91a7","7527":"9a2f91a7"}[chunkId] + ".chunk.css";
};